import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  showIcon?: boolean;
  href?: string;
  onClick?: () => void;
}
export function Button({
  children,
  className = '',
  showIcon = true,
  href,
  onClick
}: ButtonProps) {
  const sharedClasses = `group relative inline-flex items-center justify-center gap-3 bg-olive-light text-cream px-8 py-5 rounded-full font-body font-bold text-sm md:text-base tracking-wide uppercase transition-all duration-300 hover:bg-olive-gold hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0 no-underline cursor-pointer ${className}`;
  // If onClick is provided (no href), render as a button for internal actions (e.g. scroll to pricing)
  if (onClick && !href) {
    return <button onClick={onClick} className={sharedClasses} data-id="element-74">
        <span data-id="element-75">{children}</span>
        {showIcon && <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-76" />}
      </button>;
  }
  // Otherwise render as an external link with AddToCart tracking
  return <a href={href || 'https://activatureset.com/cart/52638683463972:1'} target="_blank" rel="noopener noreferrer" onClick={() => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart');
    }
  }} className={sharedClasses} data-id="element-77">
      <span data-id="element-78">{children}</span>
      {showIcon && <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-79" />}
    </a>;
}